<template>
    <label :for="elId" class="rwfc rwfc--select mb-0" :class="{ [wrapperClasses]: true }">
        <span :class="showLabel ? 'd-inline-block mr-1' : 'sr-only'">Sort By</span>
        <div class="rwfc__dropdown-triangle-layer">
          <select 
              :id="elId" 
              class="rwfc__input"
              @change="onChange()"
              ref="select">
                  <option value="" :selected="selectedField == ''">Newest First</option>
                  <option value="price__desc" :selected="selectedField == 'price' && selectedDirection == 'desc'">Price (Highest to Lowest)</option>
                  <option value="price__asc" :selected="selectedField == 'price' && selectedDirection == 'asc'">Price (Lowest to Highest)</option>
                  <template v-if="searchType == 'for-sale'">
                      <option value="roi__desc" :selected="selectedField == 'roi' && selectedDirection == 'desc'">ROI (Highest to Lowest)</option>
                      <option value="roi__asc" :selected="selectedField == 'roi' && selectedDirection == 'asc'">ROI (Lowest to Highest)</option>
                      <option value="net_yield__desc" :selected="selectedField == 'net_yield' && selectedDirection == 'desc'">Net Yield (Highest to Lowest)</option>
                      <option value="net_yield__asc" :selected="selectedField == 'net_yield' && selectedDirection == 'asc'">Net Yield (Lowest to Highest)</option>
                      <option value="gross_yield__desc" :selected="selectedField == 'gross_yield' && selectedDirection == 'desc'">Gross Yield (Highest to Lowest)</option>
                      <option value="gross_yield__asc" :selected="selectedField == 'gross_yield' && selectedDirection == 'asc'">Gross Yield (Lowest to Highest)</option>
                  </template>
          </select>
        </div>
    </label>
</template>

<script>
export default {
    props: {
        elId: {
            required: true,
            default: 'sort-by-control-input'
        },
        selectedField: { 
            type: String,
            default: 'price'
        },
        selectedDirection: { 
            type: String,
            default: 'desc'
        },
        searchType: {
            type: String,
            required: true
        },
        wrapperClasses: {
            type: String
        },
        showLabel: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        onChange(){
            let value = this.$refs.select.value;
            if(value) {
                this.$emit('sort-change', value);
            } else {
                console.warn('no value');
            }
        }
    }
}
</script>

<style>

</style>
